import {Component, Inject, OnInit} from "@angular/core";
import {SlideInAnimation} from "../../shared/utils/animations";
import {Meta, Title} from "@angular/platform-browser";
import {PageUrlService} from "../../core/services/pageUrl.service";

@Component({
  selector: "sw-about-us",
  templateUrl: "./about-us.component.html",
  animations: [SlideInAnimation]
})
export class AboutUsComponent implements OnInit {
  constructor(private pageUrlService: PageUrlService, private meta: Meta, private title: Title) {
  }

  ngOnInit() {
    this.getTags();
  }

  getTags(): void {
    const pageUrl = this.pageUrlService.getPageUrl()
    this.title.setTitle("Schoonmaakwoede Klantenservice - Ondersteuning voor de Schoonmaak van uw Woning");

    const tags = [
      {
        name: "title",
        content: "Schoonmaakwoede Klantenservice - Ondersteuning voor de Schoonmaak van uw Woning"
      },
      {
        name: "keywords",
        content: "schoonmaak, schoonmaakwoede, schoonmaak service, klantenservice, ondersteuning, professioneel schoonmaakbedrijf, woning schoonmaak, particuliere schoonmaak, zakelijke schoonmaak, grondige schoonmaak, milieu schoonmaak"
      },
      {
        name: "canonical",
        content: pageUrl
      },
      {
        name: "description",
        content: "Heeft u hulp nodig met de schoonmaak van uw woning? Neem contact op met onze klantenservice. Wij zijn er om u te helpen. Schoonmaakwoede biedt professionele schoonmaakdiensten voor zowel particulieren als bedrijven."
      },
      {
        name: "og:title",
        content: "Schoonmaakwoede Klantenservice - Ondersteuning voor de Schoonmaak van uw Woning"
      },
      {
        name: "og:description",
        content: "Heeft u hulp nodig met de schoonmaak van uw woning? Neem contact op met onze klantenservice. Wij zijn er om u te helpen. Schoonmaakwoede biedt professionele schoonmaakdiensten voor zowel particulieren als bedrijven."
      },
      {
        name: "og:url",
        content: pageUrl
      },
      {
        name: "og:image",
        content: "" // ToDo: add image url
      },
      {
        name: "robots",
        content: "index, follow"
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0"
      },
      {
        charset: "UTF-8"
      },
    ]
    tags.forEach((tag : any) => this.meta.updateTag(tag))
  }



}
